import { ButtonType } from "@/components/reusable/Button";
import { CategoryTabs } from "@/components/shared";

export default function BlogTabs({
  data,
}: {
  data: { categories: any[]; archives: any[] };
}) {
  const blogBaseUrl = `/${process.env.NEXT_PUBLIC_BLOG_SLUG}/`;
  const blogCategoryUrl = `/${process.env.NEXT_PUBLIC_BLOG_SLUG}/${process.env.NEXT_PUBLIC_BLOG_CATEGORY_SLUG}`;

  return (
    <CategoryTabs
      categories={data.categories}
      baseUrl={blogCategoryUrl}
      viewAllLabel="View All"
      buttonType={ButtonType.blog}
      buttonOutlineType={ButtonType.blogOutline}
    />
  );
}
